import Mousetrap from "mousetrap";

export default {
  created() {
    this.$nextTick(() => {
      Mousetrap.bind("esc", () => this.hide());
      this.preventBodyScroll();
    });
  },
  beforeDestroy() {
    Mousetrap.unbind("esc");
    this.allowBodyScroll();
  },
  methods: {
    hide() {
      this.allowBodyScroll();
      this.$emit("hide");
      this.toggleMobileFilters();
    },
    preventBodyScroll() {
      document.body.style.overflow = "hidden";
    },
    allowBodyScroll() {
      document.body.style.overflow = "";
    },
  },
};
